import { AtlasBodySubtitle } from '@justomx/atlas-components'

import { ContainerAtom } from 'components/atoms/Container.atom'
import { StackAtom } from 'components/atoms/Stack.atom'
import { NoDataMolecule } from 'components/molecule/NoData.molecule'
import type { ShipmentPreparationPallet } from 'types/shipment/model'
import { ShipmentPalletsOrganism } from './ShipmentPallets.organism'

interface SearchPalletsOrganismProps {
  pallets: ShipmentPreparationPallet[]
}

export const SearchPalletsOrganism = (props: SearchPalletsOrganismProps) => {
  const { pallets } = props
  return (
    <>
      {!pallets.length && (
        <ContainerAtom $padding="70px 0 0 0">
          <NoDataMolecule />
        </ContainerAtom>
      )}

      {!!pallets.length && (
        <StackAtom $direction="column" $gap={16}>
          <AtlasBodySubtitle>Resultados de búsqueda</AtlasBodySubtitle>

          <ShipmentPalletsOrganism pallets={pallets} />
        </StackAtom>
      )}
    </>
  )
}
